import React, { useEffect } from "react";

// Third Party
import { useNavigate, useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { DropdownButton } from "react-bootstrap";

// Custom Components
import Button from "../UI/Button";
import Anchors from "../UI/Anchors";
import NotificationPopup from "../UI/notification/NotificationPopup";

// APIs
import { logout } from "../../services/https/auth";

// Redux
import { RootState } from "../../store/store";
import { setMyDetails } from "../../store/usersSlice";

// Helper
import { convertToReadable, clearLocalStorage } from "../../helpers/utils";

// Hooks
import { useApiCall } from "../../hooks";
import Select from "../UI/Select";
import Image from "../UI/Image";
import ThemeToggle from "../UI/ThemeToggle";
import ContentZoomControl from "../UI/ContentZoomControl";
import { images } from "../../assets/images";
import { useTheme } from "../../context/theme/ThemeContext";

const Header = () => {
  const { isDark } = useTheme();
  const { role, currentService: service } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { call } = useApiCall();

  const { user: userDetails } = useSelector((state: RootState) => state.user);

  const handleLogout = async () => {
    call(
      () => logout(),
      () => {
        clearLocalStorage();
        dispatch(setMyDetails({}));
        navigate("/login");
      },
    );
  };

  const handleClickSelectService = (serviceName: string) => {
    navigate(`/${serviceName}/records/`);
  };

  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light">
      <div className="container-fluid">
        <div className="row w-100 m-0">
          <div className="col-md-6 col-6 d-flex justify-content-start align-items-center">
            <Image
              src={isDark ? images.LOGO_NEW_DARK : images.LOGO_NEW}
              style={{ height: 84, width: "auto" }}
            />
          </div>
          <div className="col-md-6 col-6 d-flex justify-content-end align-items-center gap-2">
            <ContentZoomControl />
            <ThemeToggle />
            <NotificationPopup />
            <DropdownButton
              title="Profile"
              className="d-flex justify-content-end"
            >
              <ul className="mb-0 p-0" style={{ listStyle: "none" }}>
                <li>
                  <span className="dropdown-item"><p className="profile-name-highlight p-0 m-0">{userDetails?.username}</p></span>
                </li>
                <li>
                  <span className="dropdown-item">
                    <p className="primary p-0 m-0">{userDetails?.email}</p>
                  </span>
                </li>
                <li>
                  <span className="dropdown-item">
                    <p className="primary p-0 m-0">Your Roles</p>
                    <ul className="inner-dropdown-list">
                      {userDetails?.roles?.map((role) => {
                        return (
                          <li className="primary p-0">
                            {convertToReadable(role.name)}
                          </li>
                        );
                      })}
                    </ul>
                  </span>
                </li>
                <li>
                  <div onClick={handleLogout} className="dropdown-item">
                    <p className="primary p-0 m-0">Logout</p>
                  </div>
                </li>
              </ul>
            </DropdownButton>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Header;
